import SparkMD5 from 'spark-md5';

/**
 * Generates a stable UUID based on the input string.
 * This is equivalent to doing md5(value)::uuid in Postgres
 * which is useful in cases where we want to have a stable ID
 * for eventually consistent data coming from the frontend
 */
export const createStableUuid = (value: string): string => {
  const hash = SparkMD5.hash(value);
  // Format as UUID: xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx
  return `${hash.slice(0, 8)}-${hash.slice(8, 12)}-${hash.slice(12, 16)}-${hash.slice(16, 20)}-${hash.slice(20)}`;
};
